import { jsonMember, jsonObject } from 'typedjson';
import { Guid, Nillable } from '@web/utils';

@jsonObject
export class AdminOrderBuyerResponse {
  @jsonMember(String)
  public readonly userId?: Nillable<Guid>;

  @jsonMember(String)
  public readonly dignity!: string;
}
